<script>
export default {
  props: ['countSelectValue', 'beginTs', 'time'],
  data () {
    return {
      rfRmsOption: {
        // tooltip: {
        //   trigger: 'axis',
        //   formatter: function (params) {
        //     var relVal = params[0].name
        //     for (var i = 0, l = params.length; i < l; i++) {
        //       relVal += '<br/>' + params[i].marker + params[i].seriesName + `&nbsp;&nbsp;&nbsp;&nbsp;` + params[i].value + 'V'
        //     }
        //     return relVal
        //   }
        // },
        legend: {
          data: ['Ua', 'Ub', 'Uc'],
          // right: 30,
          top: 20,
          formatter: ''
        },
        grid: {
          y2: 40
        },
        toolbox: {
          show: true,
          feature: {}
        },
        calculable: true,
        xAxis: {
          type: 'category',
          name: '周波数',
          data: ['', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '1', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '2', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '3', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '4', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '5', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '6', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '7', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '8', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '9', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '10', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '11', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '12'],
          axisLabel: {
            show: true,
            interval: 0
          },
          axisTick: {
            show: false
          }
        },
        yAxis: [{
          type: 'value',
          axisLabel: {
            formatter: '{value}'
          }
        }],
        series: [{
          name: 'Ua',
          type: 'line',
          showSymbol: false,
          itemStyle: {
            color: '#fccc00'
          },
          data: [0.00, 5.00, 0.00, 6.00, 0.00, 9.00, 0.00, 0.00, 3.00, 5.00, 0.00, 4.00]
        }, {
          name: 'Ub',
          type: 'line',
          showSymbol: false,
          itemStyle: {
            color: '#009800'
          },
          data: [0.00, 5.00, 0.00, 6.00, 0.00, 9.00, 0.00, 0.00, 3.00, 5.00, 0.00, 4.00]
        }, {
          name: 'Uc',
          type: 'line',
          showSymbol: false,
          itemStyle: {
            color: '#ff0000'
          },
          data: [0.00, 5.00, 0.00, 6.00, 0.00, 9.00, 0.00, 0.00, 3.00, 5.00, 0.00, 4.00]
        }
        ]
      },
      rfRmschart: {},
      eventWaveData: {},
      interval: null
    }
  },
  computed: {

  },
  watch: {
    beginTs () {
      if (this.$store.state.reqMode === 'uart') {
        this.updateData()
      }
    }
  },
  async mounted () {
    this.rfRmschart = this.$echarts.init(document.getElementById('rfRmsOptions'))
    // await this.updateData()
    if (this.$store.state.reqMode === 'udp') {
      if (!this.interval) {
        this.interval = setInterval(() => {
          this.updateData()
        }, 300)
      }
    }
  },
  destroyed () {
    if (this.interval) {
      clearInterval(this.interval)
      this.interval = null
    }
  },
  methods: {
    async updateData () {
      let params = {
        'collection': 'meter_event_data',
        'sn': this.$store.state.sn ? this.$store.state.sn : window.localStorage.getItem('sn'),
        'tsBegin': this.beginTs,
        'tsEnd': this.beginTs,
        'time': this.time,
        'fields': ['event_ware_a', 'event_ware_b', 'event_ware_c']
      }
      let data = await this.$api.queryTsData(params)
      this.eventWaveData = data.data.data
      await this.setChartOption()
    },
    setChartOption () {
      var max = 0
      var min = 0x7fffffff

      for (let i = 0; i < this.eventWaveData[0].event_ware_a.length; i++) {
        if (max < this.eventWaveData[0].event_ware_a[i]) max = this.eventWaveData[0].event_ware_a[i]
        if (max < this.eventWaveData[0].event_ware_b[i]) max = this.eventWaveData[0].event_ware_b[i]
        if (max < this.eventWaveData[0].event_ware_c[i]) max = this.eventWaveData[0].event_ware_c[i]
        if (min > this.eventWaveData[0].event_ware_a[i]) min = this.eventWaveData[0].event_ware_a[i]
        if (min > this.eventWaveData[0].event_ware_b[i]) min = this.eventWaveData[0].event_ware_b[i]
        if (min > this.eventWaveData[0].event_ware_c[i]) min = this.eventWaveData[0].event_ware_c[i]
      }

      if (max > 1000 || min < -1000) {
        for (let i = 0; i < this.eventWaveData[0].event_ware_a.length; i++) {
          this.rfRmsOption.series[0].data[i] = this.eventWaveData[0].event_ware_a[i] * 0.001
          this.rfRmsOption.series[1].data[i] = this.eventWaveData[0].event_ware_b[i] * 0.001
          this.rfRmsOption.series[2].data[i] = this.eventWaveData[0].event_ware_c[i] * 0.001
        }
        this.rfRmsOption.yAxis[0].name = 'kV'
      } else {
        this.rfRmsOption.series[0].data = this.eventWaveData[0].event_ware_a
        this.rfRmsOption.series[1].data = this.eventWaveData[0].event_ware_b
        this.rfRmsOption.series[2].data = this.eventWaveData[0].event_ware_c

        this.rfRmsOption.yAxis[0].name = 'V'
      }

      this.rfRmschart.setOption(this.rfRmsOption)
    }
  }
}
</script>

<template>
  <div class="pg">
    <div class="dataItems">
      <div class="title">电能质量事件波形记录(序号{{countSelectValue + 1}})</div>

      <div style="height: calc(100% - 50px);">
        <div id="rfRmsOptions" style="height: 100%; width: 100%"></div>
      </div>
    </div>
  </div>
</template>

<style scoped>
@import "../../../assets/css/transient.css";
.pg{
  width: 100%;
  height: 100%;
}

.dataName {
  width: 15%;
}

.dataValue {
  width: 8%;
//border-right: 1px solid black;
}

.dataNvItem {
  height: calc((100% - 70px) / 11);
}
</style>



// WEBPACK FOOTER //
// src/pages/Event/EventChart/EventChart.vue